import { Moon, Sun } from 'lucide-react';
import { useThemeStore } from '../store/themeStore';
import { Tooltip } from './ui/Tooltip';

export default function DarkModeToggle() {
  const { isDarkMode, toggleDarkMode } = useThemeStore();

  return (
    <Tooltip content={isDarkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
      <button
        onClick={toggleDarkMode}
        className="p-2 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
        aria-label="Toggle dark mode"
      >
        {isDarkMode ? (
          <Sun className="h-5 w-5" />
        ) : (
          <Moon className="h-5 w-5" />
        )}
      </button>
    </Tooltip>
  );
}

